const data = [
  {
    // Accordion in
    id: 1,
    image: "/icons/logo.svg",
    image1:
      "/icons/bnb.png",
    title: "BNBX/BNB"
  },
  {
    // Accordion in
    id: 2,
    image: "/icons/logo.svg",
    image1:
      "/icons/bnb.png",
    title: "BNB/SHIELD"
  },
  {
    // Accordion in
    id: 3,
    image: "/icons/logo.svg",
    image1:
      "/icons/bnb.png",
    title: "BNBX/SHLD"
  },
  {
    // Accordion in
    id: 4,
    image: "/icons/guard.png",
    image1:
      "/icons/guard.png",
    title: "GUARD/GUARDX"
  },
  {
    // Accordion in
    id: 5,
    image: "/icons/bnb.png",
    image1:
      "/icons/guard.png",
    title: "BNBX/GUARDX"
  },
  {
    // Accordion in
    id: 6,
    image: "/icons/andy.png",
    image1:
      "/icons/andy.png",
    title: "ANDY/ANDYX"
  },
  {
    // Accordion in
    id: 7,
    image: "/icons/bnb.png",
    image1:
      "/icons/andy.png",
    title: "BNBX/ANDYX"
  },
];

export default data;
